<template>
  <!--
    说明 
        showBtn:显示文字按钮区域 true||false
 -->
  <div class="lo_pan">
    <div v-show="!loginInfo && showBtn" class="login_card">
      <p class="login_desc">登录禾蛙解锁更多信息</p>
      <div class="login_btn" @click="handleLogin">登录/注册</div>
    </div>
    <LoginDialog
      v-if="popupVisible || showLogin"
      :visible="popupVisible || showLogin"
      @loginResult="loginResult"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import LoginDialog from '@/components/dialogs/LoginDialog'
export default {
  props: {
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: { LoginDialog },
  data() {
    return { popupVisible: false }
  },
  computed: {
    ...mapState('index', ['loginInfo', 'showLogin']),
  },
  mounted() {
    this.initLogin()
  },
  watch: {
    loginInfo(newValue, oldValue) {
      if (newValue) {
        this.requestAuth()
        this.setStateItem({
          key: 'showLogin',
          value: false,
        })
      }
    },
  },
  methods: {
    ...mapMutations('index', ['setStateItem']),
    ...mapActions('index', ['requestAuth']),
    initLogin() {
      let loginInfo = Cookies.get('loginInfo')
      if (loginInfo) {
        this.setStateItem({
          key: 'loginInfo',
          value: JSON.parse(loginInfo),
        })
      }
    },
    loginResult(result) {
      this.popupVisible = false
      this.setStateItem({
        key: 'showLogin',
        value: false,
      })
    },
    //登陆
    handleLogin() {
      this.popupVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.lo_pan {
  overflow: hidden;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  .login_card {
    width: 100%;
    padding: 21px 40px 45px;
    background-color: white;
    box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 0px 0px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    .login_desc {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5d5d5d;
      text-align: center;
    }
    .login_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #5ebfb9;

      color: white;
      height: 40px;
      border: none;
      border-radius: 5px;
      margin: 0.61rem 0 0.29rem;

      font-size: 18px;
      font-weight: 500;
      width: 100%;
    }
  }
}
</style>
